import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ambientApi } from 'src/services';

export type UseLinkEncounterDocumentsPayload = {
  encounterId: string;
  documentIds: string[];
};

export type UseUnlinkEncounterDocumentsPayload =
  UseLinkEncounterDocumentsPayload;

export const useLinkEncounterDocuments = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UseLinkEncounterDocumentsPayload) =>
      ambientApi
        .post(`/encounters/${payload.encounterId}/link_document`, {
          document_ids: payload.documentIds,
        })
        .then(({ data }) => data),
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: [
          'encounterDocumentList',
          { encounterId: payload.encounterId },
        ],
      });
    },
  });
};

export const useUnlinkEncounterDocuments = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UseUnlinkEncounterDocumentsPayload) =>
      ambientApi
        .post(`/encounters/${payload.encounterId}/unlink_document`, {
          document_ids: payload.documentIds,
        })
        .then(({ data }) => data),
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: [
          'encounterDocumentList',
          { encounterId: payload.encounterId },
        ],
      });
    },
  });
};
